import { h, Component, Fragment } from "preact";
import Router from "preact-router";

import Prematch from "../../jamibet/mobile-pages/prematch";
import PrematchTournament from "../../jamibet/mobile-pages/prematch-tournament";
import PrematchEvent from "../../jamibet/mobile-pages/prematch-event";
import Live from "../../jamibet/mobile-pages/live";
import LiveEvent from "../../jamibet/mobile-pages/live-event";
import Cashout from "../../jamibet/mobile-pages/cashout";
import Casino, { PopupGame } from "../../jamibet/mobile-pages/casino";
import Home from "./home";
import Today from "../../jamibet/mobile-pages/today";
import RecallBet from "../../jamibet/mobile-pages/recall-bet";

import ProfilePage from "../../jamibet/desktop-components/user/menu-profile";
import TransactionsHistoryPage from "../../jamibet/desktop-components/user/menu-transaction-history";
import PaymentGatewayPage from "../desktop-components/user/menu-payment-gateway";
import BetsHistoryPage from "./user/menu-bets-history";
import ManagerPage, { UserTransactionHistoryPopup } from "../../jamibet/desktop-components/user/menu-dashboard";

import FullSite from "../../jamibet/mobile-pages/full-site";
import GenericPage from "../../jamibet/mobile-pages/generic-page";

import { PromoBody, ContentBody } from "../desktop-pages/content";

import ManagerTopupPopup from "../../jamibet/desktop-components/user/manager-topup-popup";
import { ManagerTransactionHistoryPopup } from "../../jamibet/desktop-components/user/manager-transaction-history";
import ManagerLayout from "../../jamibet/desktop-components/user/manager-layout";
import { VouchersPage } from "../../jamibet/desktop-components/user/menu-vouchers";
import { ContactsPage } from "../../jamibet/desktop-components/user/menu-contact-us";
import User from "../../../services/user";
import { TransactionsHistoryMobile } from "../../jamibet/mobile-pages/user/menu-transactions-history";
import BonusNotificationModal from "../../jamibet/desktop-components/site/BonusNotificationModal";
import { MagicLinkHandler } from "../../jamibet/desktop-components/site/MagicLinkHandler";
import { MobileTournamentListPage } from "../../jamibet/mobile-pages/MobileTournamentListPage";
import { MobileTournamentLeaderboardPage } from "../../jamibet/mobile-pages/MobileTournamentLeaderboardPage";
import { BonusStatusPage } from "../../jamibet/desktop-components/user/menu-bonus-status";
import PokerPage, { PokerPageMobile } from "../../jamibet/desktop-pages/poker";
import { SignupRedirectMobile } from "../../jamibet/mobile-pages/signup-redirect";
import RoyalWinsController from "../../jamibet/mobile-components/royal-wins";
import { FortuneWheel } from "../../awrabet/mobile-components/fortune-wheel/Wheel";
import PlayingWithBonusModal from "../../awrabet/desktop-components/site/PlayingWithBonusModal";
import { TotoPage } from "../../jamibet/mobile-pages/toto-jackpot";
import { TelegramOrchestrator } from "../../awrabet/mobile-components/telergram/TelegramOrchestrator";

export default function Mobile() {
	return <Fragment>
		<Router>
			<Home path="/" default={true} />
			<RecallBet path="/recall/:betId" />
			<Prematch path="/prematch" />
			<Prematch path="/prematch/:sportId" />
			<PrematchTournament path="/prematch/:sportId/:categoryId/:tournamentId" />
			<PrematchEvent path="/prematch/:sportId/:categoryId/:tournamentId/:eventId" />
			<Live path="/live" />
			<Live path="/live/:sportId" />
			<Today path="/today" />
			<Today path="/today/:sportId" />
			<LiveEvent path="/live/event/:eventId" />
			<Cashout path="/cashout" />

			<Casino path="/virtual/:type?/:pageCode?" />
			<Casino path="/special-games/:type?/:pageCode?" />

			<MobileTournamentListPage path="/slot-tournaments" />
			<MobileTournamentLeaderboardPage path="/slot-tournaments/:tournamentId" />
			<PokerPageMobile path="/poker" />
			<SignupRedirectMobile path="/signup" />

			{!User.isLogged() ? null : <GenericPage Component={ProfilePage} path="/user" tab="profile"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={ProfilePage} path="/user/password" tab="password"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={TransactionsHistoryMobile} path="/user/transactions"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={PaymentGatewayPage} path="/user/payment-gateway/:tab?"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={BetsHistoryPage} path="/user/tickets"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={ManagerPage} path="/manager/dashboard/:tab?"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={VouchersPage} path="/user/vouchers"></GenericPage>}
			{!User.isLogged() ? null : <GenericPage Component={BonusStatusPage} path="/user/bonus-states"></GenericPage>}

			<GenericPage Component={PromoBody} path="/promo/:any?/:any?"></GenericPage>
			<GenericPage Component={ContentBody} path="/content/:any?/:any?"></GenericPage>
			<GenericPage Component={ContentBody} path="/contacts"></GenericPage>

			{!User.isLogged() ? null : <GenericPage Component={ManagerLayout} path="/management/admin" ></GenericPage>}
			{!User.isLogged() ? null : <ManagerTopupPopup path="/admin/topup/:type/:id" />}
			{!User.isLogged() ? null : <ManagerTransactionHistoryPopup path="/admin/transactions/affiliate/:username" />}
			{!User.isLogged() ? null : <UserTransactionHistoryPopup path="/admin/transactions/player/:username" />}
			<MagicLinkHandler path="/magic-link/:token" />
						
			<TelegramOrchestrator path="/tma-entry" />

			<TotoPage path="/jackpots/:tab?/:id?" />
		</Router>
		<RoyalWinsController />
		<PopupGame />
		<BonusNotificationModal />
		<PlayingWithBonusModal />

		<FortuneWheel />
	</Fragment>;
}
